import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormContainer from "../components/FormContainer";
import CheckoutSteps from "../components/CheckoutSteps";
import { saveShippingAddress } from "../slices/cartSlice";

const ShippingScreen = () => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  const [address, setAddress] = useState(shippingAddress?.address || "");
  const [city, setCity] = useState(shippingAddress?.city || "");
  const [postalCode, setPostalCode] = useState(
    shippingAddress?.postalCode || ""
  );
  const [area, setArea] = useState(shippingAddress?.area || "");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(saveShippingAddress({ address, city, postalCode, area }));
    navigate("/payment");
  };

  return (
    <FormContainer>
      <CheckoutSteps step1 step2 />
      <h1 className="text-end">משלוח</h1>
      <Form onSubmit={submitHandler}>
        <Form.Group className="my-2" controlId="country">
          <Row>
            <Col xs={12} className="text-end">
              <Form.Label>אזור</Form.Label>
            </Col>
            <Col xs={12}>
              <Form.Control
                as="select"
                required
                value={area}
                onChange={(e) => setArea(e.target.value)}
                dir="rtl"
              >
                <option value="">בחר...</option>
                <option value="צפון">צפון</option>
                <option value="חדרה, זכרון והעמקים">חדרה, זכרון והעמקים</option>
                <option value="יהודה ושומרון ובקעת הירדן">יהודה ושומרון ובקעת הירדן</option>
                <option value="שרון">שרון</option>
                <option value="מרכז">מרכז</option>
                <option value="שפלה ומישור החוף הדרומי">שפלה ומישור החוף הדרומי</option>
                <option value="מחוז ירושלים">מחוז ירושלים</option>
                <option value="דרום">דרום</option>
              </Form.Control>
            </Col>
          </Row>
        </Form.Group>

        {/* my-2 is adding margin on the top */}
        <Form.Group className="my-2" controlId="address">
          <Row>
            <Col xs={12} className="text-end">
              <Form.Label>כתובת</Form.Label>
            </Col>
            <Col xs={12}>
              <Form.Control
                type="text"
                value={address}
                required
                onChange={(e) => setAddress(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group className="my-2" controlId="city">
          <Row>
            <Col xs={12} className="text-end">
              <Form.Label>עיר</Form.Label>
            </Col>
            <Col xs={12}>
              <Form.Control
                type="text"
                value={city}
                required
                onChange={(e) => setCity(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group className="my-2" controlId="postalCode">
          <Row>
            <Col xs={12} className="text-end">
              <Form.Label>מיקוד</Form.Label>
            </Col>
            <Col xs={12}>
              <Form.Control
                type="text"
                value={postalCode}
                required
                onChange={(e) => setPostalCode(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Col>
          </Row>
        </Form.Group>

        <Row className="my-2">
          <Col className="d-flex justify-content-end">
            <Button type="submit" variant="primary">
              המשך
            </Button>
          </Col>
        </Row>
      </Form>
    </FormContainer>
  );
};

export default ShippingScreen;
